module.exports = __webpack_public_path__ + "static/499cef4d-8163-4c7d-a301-5aeb7de7665c-a3fae72dd7354d51fe6a8ba9157b67ad.jpg";